import { render } from "./AmenitiesList.vue?vue&type=template&id=a71d6cb2&scoped=true"
import script from "./AmenitiesList.vue?vue&type=script&lang=js"
export * from "./AmenitiesList.vue?vue&type=script&lang=js"

import "./AmenitiesList.vue?vue&type=style&index=0&id=a71d6cb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71d6cb2"]])

export default __exports__